import initialState from './partnerOrderInitialState';
import mutations from './partnerOrderMutation';
import actions from './partnerOrderAction';

const partnerOrderGetters = {
  poTableRecordCount: (state) => {
    const {
      partnerOrders,
      partnerOrderTableOptions: { itemsPerPage },
    } = state;
    const tableData = partnerOrders.filter((o) => o.orderLines && o.orderLines.length > 0);
    if (tableData.length === 0) {
      return 0;
    }
    return Math.ceil(tableData.length / itemsPerPage);
  },
  poTableData: (state) => {
    const { partnerOrders } = state;
    const fOrders = partnerOrders.filter((o) => o.orderLines && o.orderLines.length > 0);
    return fOrders.map((o) => {
      const order = {
        ...o,
      };
      let count = 0;
      let openCounter = 0;
      let ignoreCounter = 0;
      let cancelledCounter = 0;
      let error = false;
      let status = '';
      let shipDate = null;
      let deliveryDate = null;
      let trackingNumber = null;
      if (o.orderLines) {
        o.orderLines.forEach((oL) => {
          const {
            status: sT, shipDate: sD, deliveryDate: dD, trackingNumber: tN,
          } = oL;
          if (sT === 'Error') {
            error = true;
          } else if (oL.status === 'Ignore') {
            ignoreCounter += 1;
          } else if (sT === 'Shipped' || sT === 'Delivered') {
            count += 1;
          } else if (sT === 'Open') {
            openCounter += 1;
          } else if (sT === 'Do not ship' || sT === 'Cancelled') {
            cancelledCounter += 1;
          }
          if (!shipDate) {
            shipDate = sD;
          }
          if (!deliveryDate) {
            deliveryDate = dD;
          }
          if (!trackingNumber) {
            trackingNumber = tN;
          }
        });
      }
      if (error) {
        status = 'Error';
      } else if (openCounter === o.orderLines.length) {
        status = 'No items shipped';
      } else if (cancelledCounter === o.orderLines.length) {
        status = 'Cancelled';
      } else if (count === 0) {
        status = 'Pending fulfillment';
      } else if (count < o.orderLines.length - ignoreCounter) {
        status = 'Partially shipped';
      } else if (count === o.orderLines.length - ignoreCounter) {
        status = 'All items shipped';
      }
      order.status = status;
      if (o.isPilot) {
        order.pilotOrder = 'Yes';
      } else {
        order.pilotOrder = 'No';
      }
      order.shipDate = shipDate;
      order.deliveryDate = deliveryDate;
      order.trackingNumber = trackingNumber;
      order.corpName = order.corporation.corporationName;
      return order;
    });
  },
};

const partnerOrderModule = {
  state: initialState(),
  mutations,
  actions,
  getters: partnerOrderGetters,
};

export default partnerOrderModule;
